import _toConsumableArray from "/var/www/mol_finder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { OneHot, util } from '@tensorflow/tfjs-core';
import { OneHotProgram } from '../onehot_gpu';
import { reshape } from './Reshape';
export var oneHot = function oneHot(args) {
  var inputs = args.inputs,
      backend = args.backend,
      attrs = args.attrs;
  var indices = inputs.indices;
  var depth = attrs.depth,
      onValue = attrs.onValue,
      offValue = attrs.offValue;
  var indicesSize = util.sizeFromShape(indices.shape);
  var program = new OneHotProgram(indicesSize, depth, onValue, offValue);
  var reshaped = reshape({
    inputs: {
      x: indices
    },
    backend: backend,
    attrs: {
      shape: [indicesSize]
    }
  });
  var result = backend.runWebGLProgram(program, [reshaped], indices.dtype);
  backend.disposeIntermediateTensorInfo(reshaped);
  var outShape = [].concat(_toConsumableArray(indices.shape), [depth]);
  var out = reshape({
    inputs: {
      x: result
    },
    backend: backend,
    attrs: {
      shape: outShape
    }
  });
  backend.disposeIntermediateTensorInfo(result);
  return out;
};
export var oneHotConfig = {
  kernelName: OneHot,
  backendName: 'webgl',
  kernelFunc: oneHot
};